module.exports = __webpack_public_path__ + "static/media/mark-casual.3c73da49.jpg";